import { Button, Image } from "@/components/Elements";
import { FriendSuggestionModel } from "../../types";
import { useSendFriendRequestMutation } from "@/services/modules/chat";

const FriendSuggestion = ({
  recipient,
}: {
  recipient: FriendSuggestionModel;
}) => {
  const { fullName, userImageUrl, userId, isRequestRejected, isRequestSent } =
    recipient;
  const [sendFriendRequest] = useSendFriendRequestMutation();

  const handleSend = () => {
    sendFriendRequest({ friendId: userId });
  };

  return (
    <div className="mb-[15px] min-h-[80px] border-b-[#d3d3d3]">
      <div className="flex">
        <Image
          src={userImageUrl}
          isApiUrl
          className="w-[80px] h-[80px] rounded-[50px] border border-[#d3d3d3]"
        />
        <div className="flex-1 ml-[7px]">
          <div className="flex justify-between">
            <div className="text-[16px] font-extrabold">{fullName}</div>
          </div>
          <div className="row justify-between">
            <Button
              onClick={handleSend}
              disabled={isRequestSent}
              variant={isRequestSent ? "secondary" : "primary"}
              className="py-1"
            >
              {isRequestRejected
                ? "Rejected"
                : isRequestSent
                ? "Request Sent"
                : "Send Request"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FriendSuggestion;
